import { sort } from 'timsort'
import { extent, merge } from 'd3-array'

type ListState = State & {
    items: any[]
    extent?: [number, number]
    realtime: boolean
    buffer: any[]
}

export default function imageLogReducer(
    state: ListState = {
        start: { info: { span: { normalized: '' } } },
        items: [],
        buffer: [],
        realtime: false,
        span: { begin: 0, end: 0 }
    },
    event?: LiveEvent
): State {
    if (event?.layer > 0) {
        return state
    }

    switch (event?.type) {
        // case 'updateSpan':
        //     return {
        //         start: {info: {span: {normalized: ''}}},
        //         items: [],
        //         span: {begin: 0, end: 0}
        //     }
        case 'start':
            return {
                ...state,
                realtime: false,
                span: event.events.info._span,
                start: event.events,
                items: [],
                buffer: []
            }
        case 'span': {
            if (event.layer > 0 || state.start?.info?._span) {
                return state
            }

            return {
                ...state,
                span: event.events
            }
        }
        case 'endHistory': {
            const merged = merge(state.buffer.map(d => d.log))

            return {
                ...state,
                extent: extent(merged),
                items: state.buffer,
                realtime: true,
                buffer: []
            }
        }
        case 'event': {
            if (event.events.length === 0) {
                return state
            }
            const property = state.realtime ? 'items' : 'buffer'
            state[property] = state[property].concat(event.events)
            sort(state[property], (a: DataEvent, b: DataEvent) => a.timestamp - b.timestamp)
            if (state.realtime) {
                state.extent = extent(merge(state.items.map(d => d.log)))
            }

            return state
        }
        default:
            return state
    }
}
